import { useState } from "react";
import useBaseService from "./services/useBaseService"; // Importe o useBaseService corretamente

const useAction = (navigate) => {
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [action, setAction] = useState({}); // { action: 'delete' | 'activate', text: string, url: string, data: object, fetchData: function }
  const [selectedItem, setSelectedItem] = useState(null);
  const { del: remove } = useBaseService(navigate); // Desestruturar 'put' também

  // Função renomeada para ser mais genérica, pois o 'showConfirmation' do ProductsPage
  // já lida com o texto e a callback de confirmação.
  const showConfirmation = (
    item,
    confirmationText,
    confirmCallback,
    modalAction = null,
  ) => {
    setSelectedItem(item);
    setAction({
      text: confirmationText,
      confirmCallback: confirmCallback, // A função a ser chamada quando o modal for confirmado
      modal: modalAction,
    });
    setOpenModalConfirmation(true);
  };

  const handleDelete = (item, deleteUrl, fetchData) => {
    showConfirmation(item, `Você tem certeza que deseja excluir?`, async () => {
      await remove(deleteUrl);
      fetchData();
    });
  };

  const handleConfirmAction = async (inputValue) => {
    // Adicione o parâmetro aqui
    try {
      if (action.confirmCallback) {
        // Repassa o valor do input (quantity) para a callback do componente
        await action.confirmCallback(inputValue);
      }
      setOpenModalConfirmation(false);
    } catch (error) {
      console.error("Erro na ação confirmada:", error);
      setOpenModalConfirmation(false);
      throw error;
    }
  };

  const handleCancelConfirmation = () => {
    setOpenModalConfirmation(false);
    setSelectedItem(null);
    setAction({});
  };

  return {
    openModalConfirmation,
    showConfirmation, // Método atualizado
    handleDelete,
    handleConfirmAction,
    handleCancelConfirmation,
    selectedItem,
    setSelectedItem,
    action, // action agora tem 'text' e 'confirmCallback'
  };
};

export default useAction;
